<template>
  <b-nav-item-dropdown left no-caret ref="navdropdown" class="mailbox" id="notifyBell" @show="ocultarPointNotificacion">
    <template #button-content>
      <div class="d-flex justify-content-center align-items-center">
        <feather type="bell"></feather>
        <div class="notify">
          <span v-if="animacionNotificacion" ref="puntoNotify" class="heartbit">
          </span>
          <span v-if="hayNotificaciones" class="point"></span>
        </div>
      </div>
    </template>
    <b-dropdown-text class="border-bottom rounded-top py-2 px-1">
      <div>
        <h5 class="mb-0 fw-medium">{{ $t("notificaciones") }}</h5>
      </div>
    </b-dropdown-text>
    <VuePerfectScrollbar class="scrlbar" style="height: 250px" @scroll="onScroll">
      <b-dropdown-item v-if="numNoty === 0" class="border-bottom">
        <div class="d-flex align-items-center">
          <b-avatar variant="secondary" class="rounded-circle">
            <feather type="bell-off" class="feather-sm" style="color: white">
            </feather>
          </b-avatar>
          <h3 class="mt-3 ml-4 mr-2">{{ $t("sinNotificaciones") }}</h3>
        </div>
      </b-dropdown-item>
      <!-- El clic abre el modal lateral -->
      <b-dropdown-item :v-if="numNoty != 0" v-for="(item, i) in notify" :key="i" class="border-bottom">
        <div class="d-flex align-items-center">
          <b-img v-if="item.tipo == 'Batería baja'" src="/assets/img/iconoBateriaBaja.svg"
            class="rounded-circle icon-alert">
          </b-img>
          <b-img v-if="item.tipo == 'Impacto'" src="/assets/img/iconoImpacto.svg" class="rounded-circle icon-alert">
          </b-img>
          <b-img v-if="item.tipo == 'Geocerca'" src="/assets/img/iconoGeocerca.svg" class="rounded-circle icon-alert">
          </b-img>
          <b-img v-if="item.tipo == 'Velocidad'" src="/assets/img/iconoVelocidad.svg" class="rounded-circle icon-alert">
          </b-img>
          <b-img v-if="item.tipo == 'Movimiento'" src="/assets/img/iconoMovimiento.svg"
            class="rounded-circle icon-alert">
          </b-img>
          <b-img v-if="item.tipo == 'Auxilio'" src="/assets/img/iconoAuxilio.svg" class="rounded-circle icon-alert">
          </b-img>
          <b-avatar v-if="
            (item.tipo == 'Configuración') &
            (item.link != 'Reinicio de fábrica')
          " :variant="'secondary'" class="rounded-circle">
            <feather :type="'settings'" class="feather-sm" style="color: white"></feather>
          </b-avatar>
          <b-avatar v-if="
            (item.tipo == 'Configuración') &
            (item.link == 'Reinicio de fábrica')
          " :variant="'danger'" class="rounded-circle">
            <feather :type="'settings'" class="feather-sm" style="color: white"></feather>
          </b-avatar>
          <div class="ml-3 w-75">
            <h6 class="fw-medium mb-0">{{ item.tipo }}</h6>
            <span class="text-truncate d-block text-muted font-weight-light"
              style="margin-top: 4px; margin-bottom: 4px">
              {{ item.descripcionAlerta }}
            </span>
            <div class="row">
              <b-col cols="6">
                <p class="text-muted mb-0 alertas">{{ item.hora }}</p>
              </b-col>
              <b-col cols="6">
                <h6 v-if="item.fecha != fechaHoy" class="text-muted mb-0 alertas">
                  {{ item.fecha }}
                </h6>
                <h6 v-if="item.fecha == fechaHoy" class="text-muted mb-0 alertas">
                  {{ $t("hoy") }}
                </h6>
              </b-col>
            </div>
          </div>
        </div>

      </b-dropdown-item>
      <!-- spinner-->
      <output v-show="!todasCargadas" class="contenedorSpinner" aria-live="polite"
        style="display: flex; flex-wrap: wrap; justify-content: center; padding: 8px; border: none; background: transparent; width: 100%;">

        <div class="spinner-border" style="color:#01579B">
          <span class="visually-hidden"></span>
        </div>

      </output>



    </VuePerfectScrollbar>
    <b-dropdown-text>
      <b-link @click="verAlertas()"
        class="link d-flex align-items-center justify-content-center text-decoration-none fw-medium text-dark">
        {{ $t("vMonitoreo.verTodos") }}
        <feather type="chevron-right" class="feather-sm"></feather>
      </b-link>
    </b-dropdown-text>
  </b-nav-item-dropdown>
</template>

<script>
import VuePerfectScrollbar from "vue-perfect-scrollbar";

export default {
  components: {
    VuePerfectScrollbar
  },
  props: {
    animacionNotificacion: {
      type: Boolean,
      default: false
    },
    hayNotificaciones: {
      type: Boolean,
      default: false
    },
    numNoty: {
      type: Number,
      default: 0
    },
    notify: {
      type: Array,
      default: () => []
    },
    fechaHoy: {
      type: String,
      default: ""
    },
    todasCargadas: {
      type: Boolean,
      default: false,
    }
  },
  data() {
    return {
      loading: false, // Para evitar múltiples peticiones al mismo tiempo
    };
  },
  methods: {
    verAlertas() {
      this.$emit("verAlertas");
      this.$refs.navdropdown.hide();
    },
    ocultarPointNotificacion() {
      this.$emit("ocultarPointNotificacion");
    },

    // Método para cargar más notificaciones
    async cargarNotificacionesPorPartes() {
      if (this.loading) return;
      this.loading = true;

      // Aquí mandamo a ejecutar la funcion en el componente padre
      try {
        this.$emit("cargarNotificacionesPorPartes");
      } catch (error) {
        console.error("Error al cargar las notificaciones:", error);
      } finally {
        this.loading = false;
      }
    },

    // Detectamos el scroll y verificamos si llegamos al final
    onScroll(event) {
      const bottom = event.target.scrollHeight === Math.round(event.target.scrollTop + event.target.clientHeight);

      if (bottom) {
        this.cargarNotificacionesPorPartes(); // Cargar más notificaciones
      }
    },
  }
}
</script>
